class Anschlussstellen {
  constructor () {
    this.getData()
  }
  getData () {
    this.data = require('@/../public/syncdata/hessen_lcl_autobahn.json')
  }
  getListe () {
    return this.data
  }
}

const anschlussstellen = new Anschlussstellen()
export default anschlussstellen
